
// Define types for health data
export interface PersonalInfo {
  gender: 'Woman' | 'Man' | 'Transgender' | 'Non-binary' | 'Prefer not to respond';
  birthYear: Date;
  weight: string;
  weightUnit: 'kg' | 'lb';
  height: string;
  heightUnit: 'cm' | 'in';
  ethnicity: string;
  wakeUpTime: string;
}

export interface Symptoms {
  selectedSymptoms: string[];
}

export interface SleepAssessment {
  difficultyWakingUp: string;
  notWellRested: string;
  exhaustedWhenWaking: string;
  difficultyFallingAsleep: string;
  wakeUpTooEarly: string;
  wakeUpSeveralTimes: string;
  poorSleep: string;
}

export interface MedicalHistory {
  hasChronicConditions: boolean;
  chronicConditionsDetails: string;
  takingMedications: boolean;
  medicationsDetails: string;
  lastPeriodStart: Date | null;
  lastPeriodDuration: string;
  hadGynSurgery: boolean;
  gynSurgeryDetails: string;
  experiencedDepression: boolean;
  highStressLevels: boolean;
  healthyDiet: boolean;
  exerciseFrequency: string;
}

export interface HealthData {
  personalInfo: PersonalInfo;
  symptoms: Symptoms;
  sleepAssessment: SleepAssessment;
  medicalHistory: MedicalHistory;
}

// Default health data (for mock purposes)
export const defaultHealthData: HealthData = {
  personalInfo: {
    gender: 'Woman',
    birthYear: new Date('1985-01-01'),
    weight: '65',
    weightUnit: 'kg',
    height: '170',
    heightUnit: 'cm',
    ethnicity: 'Caucasian/White',
    wakeUpTime: '07:00',
  },
  symptoms: {
    selectedSymptoms: ['hot-flashes', 'fatigue', 'mood-changes'],
  },
  sleepAssessment: {
    difficultyWakingUp: 'Sometimes',
    notWellRested: 'Most of the time',
    exhaustedWhenWaking: 'Sometimes',
    difficultyFallingAsleep: 'Rarely',
    wakeUpTooEarly: 'Sometimes',
    wakeUpSeveralTimes: 'Rarely',
    poorSleep: 'Sometimes',
  },
  medicalHistory: {
    hasChronicConditions: false,
    chronicConditionsDetails: '',
    takingMedications: true,
    medicationsDetails: 'Vitamin D supplement',
    lastPeriodStart: new Date('2023-05-10'),
    lastPeriodDuration: '5',
    hadGynSurgery: false,
    gynSurgeryDetails: '',
    experiencedDepression: true,
    highStressLevels: true,
    healthyDiet: true,
    exerciseFrequency: 'Weekly',
  },
};
